import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type BudgetForecastDataItem from 'lumen/models/budget-forecast/data-item';

export default class BudgetForecastSegment extends Model {
  [Type] = 'budget-forecast/segment' as const;

  @belongsTo('budget-forecast/segment', { async: false, inverse: 'children' })
  declare parent: BudgetForecastSegment;

  @hasMany('budget-forecast/segment', { async: false, inverse: 'parent' })
  declare children: BudgetForecastSegment[];

  @hasMany('budget-forecast/data-item', { async: false, inverse: 'segment' })
  declare dataItems: BudgetForecastDataItem[];

  @attr('boolean') declare isFixed: boolean;
  @attr('string') declare name: string;
  @attr('boolean') declare visible: boolean;

  get depth(): number {
    if (this.parent) {
      return this.parent.depth + 1;
    }

    return 0;
  }

  get pathName(): string {
    if (this.parent) {
      return `${this.parent.pathName} / ${this.name}`;
    }

    return this.name;
  }
}
